import { useQuery } from "@tanstack/react-query";
import { SystemInputStates } from "@graylog/server-api";
import { defaultOnError } from "util/conditional/onError";
const PROBLEMATIC_STATES = /* @__PURE__ */ new Set(["FAILED", "FAILING", "SETUP"]);
const fetchStateSummary = () => SystemInputStates.summary();
const useInputStateSummary = () => {
  const { data, isLoading } = useQuery({
    queryKey: ["inputs", "state-summary"],
    queryFn: () => defaultOnError(
      fetchStateSummary(),
      "Loading input state summary failed with status",
      "Could not load input state summary."
    ),
    refetchInterval: 5e3,
    retry: false
  });
  const hasProblematicInputs = data ? Object.values(data).some((states) => states.some((s) => PROBLEMATIC_STATES.has(s))) : false;
  return { hasProblematicInputs, isLoading };
};
export default useInputStateSummary;
